import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Facebook } from 'lucide-react';
import { Button } from './ui/button';

const ReviewsSection = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Reviews & Recommendations",
      subtitle: "See What Our Clients Say About Us",
      description: "Our clients trust us with their insurance needs. Visit our Facebook page to read their experiences and join our community of satisfied customers.",
      facebookCta: "Visit Us on Facebook",
      note: "We value your feedback and appreciate every recommendation from our clients."
    },
    es: {
      title: "Opiniones y Recomendaciones",
      subtitle: "Vea lo que Nuestros Clientes Dicen Sobre Nosotros",
      description: "Nuestros clientes confían en nosotros para sus necesidades de seguros. Visite nuestra página de Facebook para leer sus experiencias y únase a nuestra comunidad de clientes satisfechos.",
      facebookCta: "Visítanos en Facebook",
      note: "Valoramos sus comentarios y apreciamos cada recomendación de nuestros clientes."
    }
  };

  const text = content[language];

  return (
    <section className="py-16 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {text.title}
          </h2>
          <p className="text-lg md:text-xl text-gray-600 mb-2">
            {text.subtitle}
          </p>
          <p className="text-base text-gray-600">
            {text.description}
          </p>
        </div>

        {/* Facebook CTA */}
        <div className="text-center">
          <a
            href="https://www.facebook.com/palerminsurance"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button 
              size="lg" 
              className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all"
            >
              <Facebook className="w-6 h-6 mr-2" />
              {text.facebookCta}
            </Button>
          </a>
          
          <p className="text-sm text-gray-500 mt-6 max-w-2xl mx-auto">
            {text.note}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
